import React from 'react';
import ReactPlayer from 'react-player';
import Header from './Header';
import Gallery01 from './Gallery01';
import Gallery02 from './Gallery02';
import Gallery03 from './Gallery03';
import Gallery04 from './Gallery04';
import Gallery05 from './Gallery05';
import Gallery06 from './Gallery06';
import Gallery07 from './Gallery07';
import Gallery08 from './Gallery08';
import * as S from './styles';

export const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Headline
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        >
          raio x de <br />
          um desfile
        </S.Headline>
        <S.Subheadline
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        >
          Thom Browne | Verão 2023
        </S.Subheadline>
        <S.Caption
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        >
          <p>
            <span>Por Pedro Diniz</span>
          </p>
          <p>
            Fotos: Getty Images, reprodução do livro “100 Anos de Moda
            Masculina”, reprodução do livro “Tom Of Finland – Bikers II”,
            reprodução do livro “Gay By the Bay – A History of Queer Culture in
            the San Francisco Bay Area”.
          </p>
        </S.Caption>
        <S.Line />
        <S.Text>
          <p
            className="drop-caps wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Se pensarmos em todos os arquétipos de homem que a história da moda
            já inventou para vender um ideal de masculinidade que se oponha ao
            estilo dito feminino, sobrariam mais exemplos do que roupas. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Invariavelmente, cairemos nos preceitos da alfaiataria, um
            território dominado pelo engessamento de ideias vinculadas ao look
            do mercado financeiro e aos heróis do cinema, quase sempre bem
            machões, do tipo James Bond. Ou então naquela imagem de jovens
            atléticos das comédias estadunidenses, com seus torsos definidos
            para o jogo nas camisetas Abercrombie &amp; Fitch. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Na última temporada de desfiles masculinos de Paris, porém, outras
            nuances desse homem se encontraram na passarela, com vestidos,
            minissaias e microshorts.
          </p>
        </S.Text>
        <Gallery01 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Parece difícil crer que Thom Browne não tenha formação acadêmica em
            moda, mas sim em negócios. Ex-nadador profissional, sua juventude
            foi marcada pelo sol californiano e, já adulto, mudou para Nova York
            depois de ter cortado e alterado roupas de seu colega de quarto,
            que, assim como ele, desejava ser ator. A junção das duas Costas do
            país é a primeira pista para entender seu mais recente desfile, que
            ainda ganhou uma boa dose de referências à cultura queer
            estadunidense.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Marido do curador do Metropolitan Museum de Nova York, Andrew
            Bolton, Browne viveu tanto a pressão de ter crescido no armário em
            sua Pensilvânia natal, numa família de executivos, quanto a
            liberdade de ter saído dele. Agora, ele desafia esses ícones de
            masculinidade, que, por mais tóxica que seja, ainda dá a tônica dos
            guarda-roupas, inclusive de homens da comunidade gay, que, para se
            encaixar e gerar uma imagem de “passabilidade” perante a sociedade
            heteronormativa, tendem a reproduzir alguns desses códigos. 
          </p>
        </S.Text>
        <Gallery02 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Por isso também Browne viaja às origens da moda masculina e mescla
            referências à cultura pop LGBTQIA+ cultivada na segunda metade do
            século 20. Mas pega esse trem de forma que o espectador não sinta o
            impacto inicial. Nos primeiros segundos do desfile de inverno 2023,
            a apresentação é interrompida por mulheres vestidas com casacos de
            tweed, vestidos e conjuntos em tons pastel, entre elas as ex-modelos
            Farida Khelfa e Marisa Berenson. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Elas surgem como convidadas, encenando que estavam atrasadas para a
            apresentação quando, na verdade, exibiam looks da linha sob medida
            de Thom. Passada a intervenção, os saiões, os xadrezes, as cores
            doces, os cortes acinturados migram para o corpo dos garotos.
          </p>
        </S.Text>
        <S.Photo5
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.CaptionPhoto5>
          Look do verão de 2023 de Thom Browne feito em tweed, um dos principais
          tecidos da coleção. Getty Images.
        </S.CaptionPhoto5>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Começa aí a lição do estilista, que iniciou a carreira em marcas
            como Ralph Lauren e Armani e desenhou para a Brooks &amp; Brothers,
            uma das etiquetas mais tradicionalmente masculinas nos EUA. Browne
            entende o que forma o guarda-roupa do homem médio estadunidense: um
            compilado de padronagens rígidas tiradas do vestuário britânico, as
            pitadas da causalidade do movimento operário, nascido na esteira da
            revolução industrial, e também elementos da cultura western detonada
            pela imagem dos caubóis, como nos personagens de Clint Eastwood. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Ciente dos estereótipos, ele paulatinamente distende os detalhes do
            machão moderno, juntando as referências atuais às das primeiras
            décadas do século passado.
          </p>
        </S.Text>
        <Gallery03 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Numa primeira leitura, salta à vista o cruzamento de diversos
            desenhos geométricos fundados pela moda europeia, com destaque para
            a vinda da Escócia e da Inglaterra. Os padrões argyle (com
            losangos), o madras (aqueles quadriculados coloridos cortados por
            linhas verticais), o tartan, o rubro esverdeado dos kilts, o
            tattersall (com quadrados minúsculos de linhas finas) e o vichy (com
            pequenos blocos bicolores e simétricos) foram unidos nos looks que
            misturam as três peças do novo terno. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Em vez de calças, saias. Em vez dos coletes pomposos, espécies de
            minipulôveres. E, por cima, casacos, jaquetas e sobretudos pesados,
            a maioria deles feita de tweed. Mas tweed não é Chanel? Também, mas,
            antes de a estilista transformar o tecido das montanhas escocesas em
            símbolo de elegância, ele era usado em roupas e acessórios
            masculinos, principalmente boinas para os dias de caça ‒ um esporte
            praticado em grupo e que sempre era assistido por cachorros.
            Adivinhe, então, qual era o formato das bolsas a tiracolo carregadas
            pelos modelos? Pois é, doguinhos de tweed.
          </p>
        </S.Text>
        <Gallery04 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Havia também bolsas como botas de caubói. O acessório dos pés foi
            para as mãos como signos do fetiche que percorre toda a coleção. É
            preciso olhar com atenção para perceber que os botões dourados e as
            listras pontuais fazem referência ao traje militar, um dos pontos de
            atenção da obra de Browne, porque ele sempre jogou com a noção de
            roupa uniformizada. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O que evoluiu agora em sua passarela é o uso dos uniformes, mas não
            os de Wall Street ou o da elite originária de seu país, mas os dos
            skatistas, com um sem-fim de bermudas arreadas na altura das
            nádegas, e também dos tenistas. Só que, em vez de shortinhos, eles
            usam minissaias tal qual o look imposto pelo esporte às mulheres ‒
            quem não se lembra do caso da tenista Serena Williams, que teve seu
            tutu de balé criticado pelos tradicionalistas quando apareceu com
            ele na quadra?
          </p>
        </S.Text>
        <Gallery05 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As bermudas largas, cortadas na altura da panturrilha, combinadas às
            peças de alfaiataria na parte de cima, contudo, não são criação de
            Thom Browne. Essa era a moda esportiva desde os anos 1900 até a
            eclosão da Segunda Guerra Mundial. O príncipe de Gales, que dá nome
            ao padrão quadriculado sobre base cinza pincelado pelo estilista,
            popularizou o look pensado para a prática de golfe.
          </p>
        </S.Text>
        <Gallery06 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Logo o modismo da época adotou a ideia que agora Browne resgata. Ele
            também mostra a versão escocesa do conjunto, com as saias
            sanfonadas, e pesca a mistura de listras que, embora tenha só virado
            moda nos 1970, ainda nos primórdios das passarelas masculinas dos
            Estados Unidos, eram o uniforme das equipes dos clubes de
            cavalheiros dos anos 1910. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Os debruns coloridos na lapela dos paletós também reeditam o look de
            alfaiataria das comunidades universitárias.
          </p>
        </S.Text>
        <S.PhotoWrapper>
          <S.Photo14
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          />
          <S.CaptionPhoto14>
            <p className="mobile">
              Modelos nos bastidores da semana de moda de Earls Court, em
              Londres, nos anos 1970. | Foto: Reprodução do livro “100 anos de
              moda masculina”.
            </p>
          </S.CaptionPhoto14>
          <S.Photo15
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          />
          <S.CaptionPhoto15>
            <p className="desktop">
              De cima para baixo, modelos nos bastidores da semana de moda de
              Earls Court, em Londres, nos anos 1970; e detalhes em debruns nos
              looks dos participantes da Royal Henley Regatta, na Inglaterra, em
              1908. Reprodução do livro “100 anos de moda masculina”.
            </p>
            <p className="mobile">
              Detalhes em debruns nos looks dos participantes da Royal Henley
              Regatta, na Inglaterra, em 1908 Foto: reprodução do livro “100
              anos de moda masculina”.
            </p>
          </S.CaptionPhoto15>
        </S.PhotoWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As contradições se cruzam na passarela, que estuda esses signos com
            a proposta de escancarar a força brutal que subjuga nossas mentes. E
            é aí que entra o jogo de ideias mais subversivo da coleção. Os
            marinheiros fetichizados pela dupla de fotógrafos Pierre et Gilles e
            pelo artista finlandês Touko Valio Laaksonen, tornado ícone sob o
            pseudônimo Tom of Finland, cruzam esses estereótipos nos detalhes.
            Há propostas literais, como no look de marinheiro revisto em golas,
            calça e pendor sexual, e jaquetas cortadas nos ombros, parte
            inerente do uniforme do motoqueiro da obra de Finland.
          </p>
        </S.Text>
        <Gallery07 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Como nas ilustrações em nanquim que chocaram os 1960 e foram ainda
            mais demonizadas com o advento da aids, os garotos exibiam os
            cofrinhos de suas bundas, onde é possível ver outro símbolo
            apropriado pela cultura LGBTQIA+ fundido à coleção: a jockstrap. A
            peça, que segura as partes íntimas e é sustentada pela fita envolta
            no traseiro, serve de proteção para os esportistas que praticam
            modalidades de impacto corpo a corpo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Nada mais certo, então, que com a libertação sexual dos 1970, ela
            tenha virado peça fetiche de outra modalidade de impacto corporal  ‒
            e uma bem mais prazerosa. Aussiebum, Andrew Christian, Mister B.,
            Barcode. Todas essas marcas, reconhecidas da cultura queer, fizeram
            fama em torno dela.
          </p>
        </S.Text>
        <Gallery08 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O desfile orbita em torno do balanço entre a tradição e a subversão,
            onde o sexo, o desejo carnal que mora em cada detalhe do corpo
            exposto, é o centro de todos os atos. Mas ele também trata de
            dominação entre duas pessoas, um jogo que oprime não apenas
            heterossexuais, mas todas as relações baseadas na pretensa
            superioridade de um em relação ao outro, inclusive na comunidade
            gay. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A masculinidade reproduzida em músculos e traços de força é
            explorada por Browne nas estampas de âncora, o peso que os homens
            carregam pelo corpo, e as cordas que laçam as liberdades
            individuais, outra referência aos marinheiros e caubóis.
          </p>
        </S.Text>
        <S.Photo20
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.CaptionPhoto20>
          Look do verão 2023 de Thom Browne mescla padrões quadriculados e
          listrados em conjunto esportivo que era padrão dos anos 1920. Getty
          Images
        </S.CaptionPhoto20>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Vale destacar como o estilista apostou nesse contraste quando exibiu
            âncoras presas à cabeça dos modelos. O peso da masculinidade também
            foi expressa nas cartolas, suspensas nas cabeças de uma dupla de
            modelos vestidos com alfaiataria tradicional, em preto e branco, mas
            com as pernas descobertas  ‒ um deles exibia um pedaço de
            cinta-liga, revelando desejos escondidos embaixo daquela aparente
            aura de “decência”. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A cartola é o símbolo de uma das imagens mais reconhecíveis dos
            Estados Unidos: o cartaz do Tio Sam. Usado pelo exército para
            recrutar jovens e cujo personagem envelhecido, com o dedo em riste,
            cobra patriotismo e parece dizer “seja homem”, ele é um imperativo
            que todos os nascidos com um pênis ouviram em algum momento da
            vida. 
          </p>
        </S.Text>
        <S.Photo21
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.CaptionPhoto21>
          Cartaz do Tio Sam usado na Primeira Guerra Mundial para o alistamento
          de jovens no exército. Reprodução
        </S.CaptionPhoto21>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As cores da bandeira estadunidense (azul, vermelho e branco) reluzem
            no cartaz e simbolizam o trio cromático que Thom Browne adotou tanto
            nesse desfile quanto na iconografia de sua grife, uma saída para
            destacar que, mesmo reproduzindo códigos europeus em sua moda, sua
            etiqueta e as nuances das roupas são puro EUA. Não por menos, para
            responder a um país cuja Corte Suprema discute a possibilidade de
            reverter o direito constitucional da união homoafetiva e é terra de
            um estado como a Flórida, que acaba de proibir professores de usarem
            o termo gay nas salas de aula, Browne encerra seu estudo com uma
            dedada, e uma paulada literal, na cara do conservadorismo
            republicano.
          </p>
        </S.Text>
        <S.Photo22
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.CaptionPhoto22>
          Looks de verão 2023 de Thom Browne reproduzem estética militar fundida
          à cartola que é símbolo do Tio Sam. Em vez da estrela, o estilista
          opta pela âncora que define a iconografia do desfile. Getty Images
        </S.CaptionPhoto22>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Um caubói com traje completo, só que de jeans, o tecido mais
            estadunidense de todos, entrou no final da apresentação, galopando
            como em um cavalo. Ainda na boca de cena, ele virou as costas para a
            câmera para exibir, com orgulho, sua bunda branca empinada pela
            jockstrap. Na cabeça, tinha um chapéu, que, em vez da estrela do Tio
            Sam, foi bordado com a âncora símbolo da coleção. Assim que ele
            virou para a plateia, mostrou, com movimentos de vaivém, a parte da
            frente do look, uma jaqueta cavada que revela o torso e foi
            combinada à calça, cuja parte da frente tem costurada uma
            protuberância, feita para caber seu pênis, o centro de toda a
            opressão de quem usa o falo para subjugar  ‒ esse objeto de carne
            venerado pelo homem desde a antiguidade.
          </p>
        </S.Text>
        <S.Limiter>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=N1nG-Al_JyY"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.Limiter>

        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Browne, por fim, consegue apontar para os presentes o que parece
            escondido na alma desse homem conservador, ao mesmo tempo que
            liberta a comunidade cujos desejos são reprimidos pela
            masculinidade. Era uma imagem dúbia, de sexualidade latente, e
            extremamente poderosa vinda de um homem que agrada do executivo
            moderninho aos políticos poderosos, do garoto desconstruidão aos
            meninos que enxergam em sua roupa uma ferramenta para ser apenas
            quem são. 
          </p>
        </S.Text>
        <S.Separator />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Raio-X de um desfile é a uma seção fixa da ELLE View, em que todos
            os meses examinamos uma apresentação recente, trazendo detalhes
            sobre as roupas e explicando por que vale a pena você saber mais
            sobre ela.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
